import { dateFormatter } from '@fareye/common'

export const displayTime = (time: any) => (time ? dateFormatter(time) : '-')

export const displayTimeSecondFormat = (time: any) =>
  time ? dateFormatter(time, 'ddMMMhhmmA') : '-'
export const displayTimeWithETAATA = (time: any, type: 'ETA' | 'ATA') =>
  time ? type + ': ' + dateFormatter(time, 'ddMMMhhmmA') : '-'
